// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a248356","239":"b60b80ec","453":"22d61625","634":"ab4225fc"}[chunkId] + ".chunk.js";
};